import React from "react";
import CircleCheckmarkFill from "../../icons/CircleCheckmark_Fill";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from "../../reusable-components/button";

const ActivationSuccess = () =>
{
  const { t } = useTranslation();
  const { productUrls } = useSelector((state) => state.activation);
  return (
    <div className="pagination-view">
      <div className="row text-body">
        <div className="display-flex">
          <span style={{ height: 30, width: 30 }}><CircleCheckmarkFill fill="#4b973e" /></span>
          <h3 className="margin-tp-none margin-bt-16">{t('successScreen.success')}</h3>
        </div>
        <div>
          {t('successScreen.activatedSuccessfully')}
        </div>
        <div>
          {t('successScreen.continueToLogin')}
        </div>
        <a href={productUrls.loginPage}>
          <Button isDisabled={false} buttonText={t('successScreen.continueButton')} classes="margin-tp-16" loader={false} />
        </a>
      </div>
    </div>
  );
};

export default ActivationSuccess;
